<template>
  <VideoPlayer />
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";

// https://lamberti-media-repository.s3.eu-south-1.amazonaws.com/b4934dd1-5b2d-455a-91d0-5229e6bf2d9b_original.mp4

export default {
  name: "App",
  components: {
    VideoPlayer,
  },
};
</script>
